<template>
  <div v-loading.fullscreen.lock="loadingContent" element-loading-text="Aguarde um momento...">

    <ed-form :data="formData" :response="response" :config="config" :itens="formDataItems">
      <div slot="form-footer" >
        <div class="row">
          <div class="col-md-12 text-left">
            
            <Config :consulta="formData.result"/>

            <b-list-group v-if="false">
              <b-list-group-item @click="onASO" button title="Clique aqui para imprimir o ASO desta consulta">
                <i class="fa fa-print" aria-hidden="true"/>
                Imprimir ASO
              </b-list-group-item>
              
              <b-list-group-item @click="onFemo"  button title="Clique aqui para imprimir a Ficha Clínica desta consulta">
                <i class="fa fa-print" aria-hidden="true"/>
                Imprimir Ficha Clínica
              </b-list-group-item>

              <b-list-group-item disabled button title="Clique aqui para Liberar o ASO desta consulta">
                <i class="fa fa-lock" aria-hidden="true"/>
                Liberar ASO
                <!-- <b-card-body>
                </b-card-body> -->
              </b-list-group-item>

            </b-list-group>

          </div>  
        </div>
      </div>
    </ed-form>
  </div>
</template>

<script>

import Rest from "common/rest";
import EdForm from 'common/form'
import EdAlert from 'common/alert'
import ItemsFormCadastrar from './_form/consulta-editar'

import Pcmso from 'appsCredenciada/consulta/_includes/pcmso'
import Historico from 'appsCredenciada/consulta/_includes/historico'
import Config from './configuracao/index'

export default {
  components: {EdForm,EdAlert,Historico,Pcmso,Config},
  mixins: [Rest],
  data() {
    return {
      loadingContent:false,
      loadingSave:false,
      response:{},
      formDataItems:[],
      config:{
        tipo:[],
        readonly:{
          id_fdt:true,
          id_ghe:true,
          id_funcao:true,
          id_tipo_aso:true,
          data_age:true,
          funcionario:true,
          obs:true,
        }
      },
      pcmso:null,
      consulta_historico:null,
      formData:{
        id: 0,
        data_age:null,
        id_funcionario:null,
        funcionario:null,
        id_tipo_aso:null,
        id_funcao: null,
        id_fdt:null,
        id_ghe:null,
        exames:[],
        obs:null,
        result:null,
      },
      showAso:false,
      showFemo:false,
      tabSelected:'tab-acompanhamento'
      
    };
  },

  created() {
  },

  mounted(){
    this.formDataItems = ItemsFormCadastrar;
    this.getConsulta();

    this.$events.on('consulta-liberado', eventData => {
      this.getConsulta();
    });
  },

  methods: {

      onASO(){
        this.showAso = !this.showAso;
      },

      onFemo(){
        this.showFemo = !this.showFemo;
      },

      getConsulta(){

        this.loadingContent = true;
        this.response = {};

        this.get('consulta/externa/'+this.$route.params.consulta).then((result) =>{
          result = result[0];

          this.loadingContent = false;
          this.response = result;

          if(result.status == 200){
            this.formData ={
              id: result.data.id,
              data_age:this.convertDate(result.data.data_age),
              funcionario:result.data.funcionario.nome,
              id_tipo_aso:result.data.tipo_aso.descricao,
              id_funcao: result.data.funcao.nome,
              id_fdt:result.data.fdt.pcmso+' ('+result.data.fdt.descricao+')',
              id_ghe:result.data.ghe.ghe+' ('+result.data.ghe.descricao+')',
              obs:result.data.obs,
              result:result.data
            };
          }
          else{
            if(result.status == 404)
              this.toRoute({name:'credenciada.consulta'})
          }
        });
      },
  }
};
</script>



// WEBPACK FOOTER //
// editar.vue?65c844e4